module.exports = __webpack_public_path__ + "static/app-forum-25f86344959819d4e8cbe76c9fa5daf2.png";